import { UxAsset } from '.';
import VehicleType from '../enums/vehicle-type';
import { AssetData } from './asset';
import GenericAsset from './generic-asset';

export type PowersportsAssetData = AssetData & {
  id?: string | null;
  vin?: string | null;
  stockNumber?: string | null;
  category?: string | null;
  subcategory?: string | null;
  make?: string | null;
  model?: string | null;
  year?: string | null;
  color?: string | null;
  condition?: string | null;
  on_sale?: boolean | null;
  location?: string | null;
  dealer_id?: string | null;
  ad_id?: string | null;
};

export default class PowersportsAsset extends GenericAsset<PowersportsAssetData> {
  id: string | null;
  vin: string | null;
  stockNumber: string | null;
  category: string | null;
  subcategory: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  color: string | null;
  condition: string | null;
  on_sale: boolean | null;
  location: string | null;
  dealer_id: string | null;
  ad_id: string | null;

  constructor(data: PowersportsAssetData) {
    super('powersport', VehicleType.POWERSPORTS, data);
    this.id = data.id !== undefined ? data.id : null;
    this.vin = data.vin !== undefined ? data.vin : null;
    this.stockNumber = data.stockNumber !== undefined ? data.stockNumber : null;
    this.category = data.category !== undefined ? data.category : null;
    this.subcategory = data.subcategory !== undefined ? data.subcategory : null;
    this.make = data.make !== undefined ? data.make : null;
    this.model = data.model !== undefined ? data.model : null;
    this.year = data.year !== undefined ? data.year : null;
    this.color = data.color !== undefined ? data.color : null;
    this.condition = data.condition !== undefined ? data.condition : null;
    this.on_sale = data.on_sale !== undefined ? data.on_sale : null;
    this.location = data.location !== undefined ? data.location : null;
    this.dealer_id = data.dealer_id !== undefined ? data.dealer_id : null;
    this.ad_id = data.ad_id !== undefined ? data.ad_id : null;
  }

  /**
   * Convert a PowersportsAsset to the fields the UX server expects
   */
  toUxServer(): UxAsset {
    return {
      ...super.toUxServer(),
      product_id: this.id ? this.id.toString() : null,
      product_vin: this.vin ? this.vin.toString() : null,
      product_stock_number: this.stockNumber ? this.stockNumber.toString() : null,
      product_category: this.category ? this.category.toString() : null,
      product_subcategory: this.subcategory ? this.subcategory.toString() : null,
      product_make: this.make ? this.make.toString() : null,
      product_model: this.model ? this.model.toString() : null,
      product_year: this.year ? this.year.toString() : null,
      product_color: this.color ? this.color.toString() : null,
      product_condition: this.condition ? this.condition.toString() : null,
      product_price: this.price,
      product_original_price: this.originalPrice,
      product_on_sale: typeof this.on_sale === 'boolean' ? this.on_sale : false,
      product_location: this.location ? this.location.toString() : null,
      product_origin_url: this.origin_url.toString(),
      product_dealer_id: this.dealer_id ? this.dealer_id.toString() : null,
      product_ad_id: this.ad_id ? this.ad_id.toString() : null,
      product_vehicle_type: this.vehicleType
    };
  }
}
